"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5187],{

/***/ 25187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_NewsletterContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@aaronhayes/react-use-hubspot-form/build/module/index.js
var build_module = __webpack_require__(14036);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Newsletter/index.tsx






const Newsletter = _ref => {
  let {
    title,
    description
  } = _ref;
  (0,build_module/* useHubspotForm */.k1)({
    portalId: "6886918",
    formId: "53a0159f-88e8-4ed7-b479-9d3d58e4e8b5",
    target: '#newsletter-form'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bg: "primaryGreen.600",
    px: {
      base: '0.375rem',
      md: null
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "6xl",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        maxW: "6xl",
        py: "xxl",
        templateColumns: {
          base: '1fr',
          md: '4fr 5fr'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          mb: {
            base: 'l',
            md: '0'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseWhite",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.5rem",
            lineHeight: "31px",
            letterSpacing: ".68px",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseWhite",
            fontFamily: "Montserrat-SemiBold",
            fontSize: ".875rem",
            lineHeight: "18px",
            letterSpacing: ".2px",
            marginTop: "xs",
            children: description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          id: "newsletter-form",
          mt: "-1rem",
          fontFamily: "Montserrat-Medium",
          color: "baseWhite"
        })]
      })
    })
  });
};

/* harmony default export */ var components_Newsletter = (Newsletter);
;// CONCATENATED MODULE: ./src/containers/NewsletterContainer.tsx




const NewsletterContainer = _ref => {
  let {
    title,
    description
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Newsletter, {
    title: title,
    description: description
  });
};

/* harmony default export */ var containers_NewsletterContainer = (NewsletterContainer);

/***/ })

}]);